import React from 'react'
import createIcon from 'mz-icons/utils/createIcon'

export default createIcon({
  iconName: 'parking',
  icon: [
    14,
    16,
    null,
    null,
    null,
    <g fill="#FFF" fillRule="evenodd" key="parking">
        <path fillRule="nonzero" d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2zm0-1h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"/>
        <path d="M5.33 8.66V12H4.205V3.469h3.147c.933 0 1.665.238 2.194.715.53.476.794 1.107.794 1.892 0 .828-.259 1.466-.777 1.913-.517.448-1.258.671-2.223.671H5.33zm0-.92h2.022c.601 0 1.062-.141 1.382-.425.32-.283.48-.692.48-1.227 0-.508-.16-.914-.48-1.219-.32-.305-.76-.463-1.318-.474H5.33V7.74z"/>
    </g>,
  ],
});
